import { PlusOutlined } from '@ant-design/icons'
import { Button, Dropdown, Empty } from 'antd'
import { uniqBy } from 'lodash'
import { object } from 'prop-types'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
	editTemplateStepInfo,
	editTemplateStepAdd,
} from '~/states/modules/editTemplate'
import { clearGroupsData, getGroupList } from '~/states/modules/groups'
import StepFactory from './steps'

const stepFactory = new StepFactory()

const Workflow = ({ form }) => {
	const dispatch = useDispatch()

	useEffect(() => {
		// This component shares the same group reducer with the users page, so we clear the groups store to make sure we will show an updated groups list
		dispatch(clearGroupsData())
	}, [dispatch])

	const steps = useSelector(
		({
			editTemplate: {
				data: {
					workflow: { steps },
				},
			},
		}) => steps // steps.map((step) => prepareStepsDataForEditing(step))
	)

	const groupsLoaded = useSelector(({ groups }) => groups.loaded)
	const groupOptions = useSelector(({ groups }) => {
		if (groups.loaded) {
			return groups.groupsList.map((group) => {
				return { value: group.id, label: group.name }
			})
		} else {
			return uniqBy(
				steps
					.filter((step) => step.initialGroup)
					.map((step) => {
						return {
							value: parseInt(step.initialGroup.id),
							label: step.initialGroup.name,
						}
					}),
				'value'
			)
		}
	})
	const loadGroups = () => {
		if (!groupsLoaded) {
			dispatch(getGroupList())
		}
	}

	const handleUpdateStep = (index, changedData) => {
		const convertGroupFormat = (step) => {
			if (step.responsible_group && groupOptions.length) {
				const { value: id, label: name } = groupOptions.find(
					(group) => parseInt(group.value) === parseInt(step.responsible_group)
				)
				return { id, name }
			}
		}

		const newStep = { ...steps[index], ...changedData }
		const responsibleGroup = convertGroupFormat(newStep)
		newStep.responsible_group = responsibleGroup
		delete newStep.initialGroup
		dispatch(editTemplateStepInfo({ index, step: newStep }))
	}

	const handleAddStep = (selection) => {
		const count = Object.keys(steps).length
		const newStep = stepFactory.getStepSpec(selection.key).initialState
		dispatch(editTemplateStepAdd({ newStep, count }))
	}

	const newStepMenuItems = stepFactory
		.getStepsSpecs()
		.map(({ type, label }) => {
			return { label, key: type, onClick: handleAddStep }
		})

	return (
		<div style={{ maxWidth: '40rem' }}>
			{!steps.length ? (
				<Empty description="Sem Passos" style={{ marginBottom: '1.5rem' }} />
			) : (
				steps.map((step, index) => {
					const Step = stepFactory.getStepSpec(step.type).component
					return (
						<Step
							key={index}
							form={form}
							step={step}
							loadGroups={loadGroups}
							groupOptions={groupOptions}
							loadingGroups={true}
							index={index}
							updateStep={handleUpdateStep}
						/>
					)
				})
			)}
			<Dropdown menu={{ items: newStepMenuItems }}>
				<Button
					block
					icon={<PlusOutlined />}
					size="medium"
					type="dashed"
					style={{ height: '4rem', marginBottom: '1rem' }}>
					Acrescentar Passo
				</Button>
			</Dropdown>
		</div>
	)
}

export default Workflow

Workflow.propTypes = {
	form: object,
}
